import { sendIncidentColumbusUseCase } from '@src/main/modules/other_incidents/application/use-cases/send/send-incident-columbus.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useSendToColumbus = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  return useMutation({
    mutationFn: async (id: string) => await sendIncidentColumbusUseCase(id, tokenProvider),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incidents'] });
    },
  });
};
